module.exports = __webpack_public_path__ + "static/media/logo.a557aa55.svg";